import { SharedModule } from 'app/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpHeaders, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PasswordResetService } from './password-reset.service';
import { PasswordResetRoutingModule } from './password-reset.routing';
import { PasswordResetComponent } from './password-reset.component'
import { FooterComponent } from "../../footer/footer.component";


@NgModule({ declarations: [
        PasswordResetComponent
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PasswordResetRoutingModule,
        SharedModule,
        FooterComponent], providers: [PasswordResetService, provideHttpClient(withInterceptorsFromDi())] })
export class PasswordResetModule { }
